import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getInvoices } from '../../../services/invoices';
import { IInvoice } from '../../../services/invoices/types';

export const ThunkGetInvoices = createAsyncThunk<IInvoice[]>(
  `${storeResources.INVOICES}/getInvoices`,
  () => getInvoices().then(res => res.data),
);
